import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  icon: { marginRight: 5 },
  button: {
    fontSize: 14,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      padding: '2px',
    },
  },
}));
